export default __webpack_public_path__ + "static/media/header-background-investments.8f12cbe0.webp";